import type { Role } from '@getcircuit/schema'

import type { ClientContext } from '../../types'

type CreateUserParams =
  | {
      email: string
      teamId?: string
      memberId?: string
      roles: Role[]
      createdAt: number
    }
  | {
      phone: string
      teamId?: string
      memberId?: string
      roles: Role[]
      createdAt: number
    }

type CreateUserResponse =
  | {
      id: string
      email: string
      roles: string[]
      type: string
    }
  | {
      id: string
      teamId: string
      email: string
      roles: string[]
      type: string
    }

/**
 * Documentation: https://www.notion.so/circuit/B2B-Firebase-Functions-b98eb289350e4c3ea9115fe5d2c9e677#7ffe11484b7e4ae1bb2de9686742be3f
 * */
export function createUser(context: ClientContext, params: CreateUserParams) {
  return context.request<CreateUserResponse>('/users', {
    method: 'POST',
    withAuth: true,
    json: params,
  })
}
